{
  "entry": {
    "title": "ஆணை உள்ளிடு",
    "subtitle": "கணினிமயமாக்கப்பட்ட வழங்குநர் ஆணை உள்ளீடு (CPOE)",
    "searchSection": {
      "title": "ஆணைகளைத் தேடி சேர்",
      "cosignNotice": "உங்கள் ஆணைகள் செயல்படுத்தப்படுவதற்கு முன் கூட்டு கையொப்பம் தேவை."
    },
    "pending": {
      "title": "நிலுவை ஆணைகள்",
      "clearAll": "அனைத்தையும் அழி",
      "collapseAria": "விவரங்களை மறை",
      "expandAria": "விவரங்களை விரிவாக்கு",
      "removeAria": "ஆணையை அகற்று",
      "startDateTime": "தொடக்க தேதி/நேரம்",
      "ariaStartDate": "ஆணை தொடக்க தேதி",
      "ariaStartTime": "ஆணை தொடக்க நேரம்",
      "clinicalIndication": "மருத்துவ அறிகுறி",
      "clinicalIndicationPlaceholder": "ஆணைக்கான காரணம்…",
      "specialInstructions": "சிறப்பு வழிமுறைகள்",
      "specialInstructionsPlaceholder": "செயல்படுத்தும் துறைக்கான கூடுதல் வழிமுறைகள்…",
      "diagnosisLabel": "நோயறிதல் (ICD-10)",
      "diagnosisPlaceholder": "ICD-10 நோயறிதல் குறியீட்டைத் தேடு…",
      "noActiveEncounter": "செயல்படும் சந்திப்பு இல்லை — ஆணைகள் வழங்க முடியாது.",
      "placing": "சமர்ப்பிக்கப்படுகிறது…",
      "placeAll": "அனைத்து ஆணைகளையும் சமர்ப்பி ({{count}})"
    },
    "active": {
      "title": "செயல்படும் ஆணைகள்",
      "loading": "ஆணைகளை ஏற்றுகிறது…",
      "emptyAll": "இந்த நோயாளிக்கு ஆணைகள் எதுவும் இல்லை.",
      "emptyFiltered": "{{type}} ஆணைகள் எதுவும் இல்லை.",
      "columns": {
        "orderNumber": "ஆணை எண்",
        "name": "பெயர்",
        "type": "வகை",
        "priority": "முன்னுரிமை",
        "status": "நிலை",
        "orderedBy": "ஆணை வழங்கியவர்",
        "orderedDate": "ஆணை தேதி",
        "actions": "செயல்கள்"
      },
      "external": "வெளி",
      "externalTitle": "{{source}} இல் இருந்து வெளி ஆணை",
      "externalTitleWithId": "{{source}} இல் இருந்து வெளி ஆணை (#{{id}})",
      "providerPlaceholder": "மருத்துவர் #{{id}}",
      "actions": {
        "complete": "முடி",
        "cancel": "ரத்து",
        "completeTooltip": "ஆணையை முடிக்க",
        "cancelTooltip": "ஆணையை ரத்து செய்"
      }
    },
    "cancelDialog": {
      "title": "ஆணையை ரத்து செய்",
      "prompt": "{{orderName}} ஐ ரத்து செய்வதற்கான காரணத்தைத் தரவும்.",
      "placeholder": "ரத்து செய்வதற்கான காரணம் (கட்டாயம்)…",
      "goBack": "திரும்பு",
      "confirm": "ரத்தை உறுதிப்படுத்து"
    },
    "toast": {
      "cancelSuccess": "ஆணை வெற்றிகரமாக ரத்து செய்யப்பட்டது",
      "cancelError": "ஆணையை ரத்து செய்ய முடியவில்லை",
      "completeSuccess": "ஆணை முடிக்கப்பட்டதாக குறிக்கப்பட்டது",
      "completeError": "ஆணையை முடிக்க முடியவில்லை",
      "noActiveEncounter": "இந்த நோயாளிக்கு செயல்படும் சந்திப்பு இல்லை. முதலில் ஒரு சந்திப்பை உருவாக்கவும்.",
      "placedSuccess_one": "{{count}} ஆணை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
      "placedSuccess_other": "{{count}} ஆணைகள் வெற்றிகரமாக சமர்ப்பிக்கப்பட்டன",
      "medicationFieldsRequired_one": "{{names}} பரிந்துரைக்க அளவு, வழி மற்றும் அதிர்வெண் தேவை",
      "medicationFieldsRequired_other": "{{count}} மருந்துகளுக்கு அளவு, வழி மற்றும் அதிர்வெண் தேவை: {{names}}",
      "medicationNotInFormulary_one": "{{names}} மருந்துப் பட்டியலுடன் இணைக்கப்படவில்லை; ஒவ்வாமை, இடைவினை அல்லது அளவைச் சரிபார்க்க முடியாது — மருந்துப் பக்கத்திலிருந்து பரிந்துரைக்கவும்",
      "medicationNotInFormulary_other": "{{count}} மருந்துகள் மருந்துப் பட்டியலுடன் இணைக்கப்படவில்லை; சரிபார்க்க முடியாது: {{names}} — மருந்துப் பக்கத்திலிருந்து பரிந்துரைக்கவும்",
      "placedError_one": "{{count}} ஆணையை சமர்ப்பிக்க முடியவில்லை",
      "placedError_other": "{{count}} ஆணைகளை சமர்ப்பிக்க முடியவில்லை",
      "orderSetApplied": "{{name}} இலிருந்து {{count}} ஆணைகள் சேர்க்கப்பட்டன — கையொப்பமிடும் முன் மறுபரிசீலனை செய்யவும்"
    }
  },
  "catalog": "ஆணை பட்டியல்",
  "orderedBy": "ஆணையிட்டவர்",
  "orderedDate": "ஆணையிட்ட தேதி",
  "scheduledDate": "திட்டமிட்ட தேதி",
  "completedDate": "முடிக்கப்பட்ட தேதி",
  "lab": "ஆய்வகம்",
  "imaging": "காட்சிப்படுத்தல்",
  "medication": "மருந்து",
  "procedure": "செயல்முறை",
  "consultation": "ஆலோசனை",
  "priority": {
    "label": "முன்னுரிமை",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "அவசரம்",
      "routine": "வழக்கமான",
      "scheduled": "திட்டமிடப்பட்டது",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "ஆணை நிலை",
    "values": {
      "draft": "வரைவு",
      "pending": "நிலுவையில்",
      "pendingCosign": "இணை கையொப்பம் நிலுவையில்",
      "signed": "கையொப்பமிடப்பட்டது",
      "sent": "அனுப்பப்பட்டது",
      "active": "செயலில்",
      "ordered": "ஆணையிடப்பட்டது",
      "inProgress": "நடைபெறுகிறது",
      "holdForVerify": "சரிபார்ப்புக்காக நிறுத்தப்பட்டது",
      "completed": "முடிக்கப்பட்டது",
      "cancelled": "ரத்து செய்யப்பட்டது",
      "discontinued": "நிறுத்தப்பட்டது",
      "archived": "காப்பகப்படுத்தப்பட்டது",
      "pendingClarification": "விளக்கம் நிலுவை",
      "suspended": "நிறுத்தப்பட்டது",
      "unknown": "தெரியவில்லை"
    }
  },
  "entryFields": {
    "searchPlaceholder": "ஆணைகளைத் தேடு (ஆய்வு, படிம, மருந்து, செயல்முறை)…",
    "frequency": "அதிர்வெண்",
    "dose": "மருந்தளவு",
    "route": "வழங்கல் வழி",
    "indication": "குறிகாட்டி",
    "duration": "காலம்",
    "comments": "குறிப்புகள்",
    "signOrder": "ஆணையை கையொப்பமிடு",
    "holdOrder": "ஆணையை நிறுத்து",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "ஆணை பட்டியல்",
    "searchPlaceholder": "பெயர், குறியீடு அல்லது ஒத்த சொல்லால் தேடு…",
    "categories": "வகைகள்",
    "favorites": "பிடித்தவை",
    "recentlyUsed": "சமீபத்தில் பயன்படுத்தியவை",
    "restricted": "கட்டுப்படுத்தப்பட்டவை",
    "searchCatalog": "பட்டியலில் தேடு",
    "tabs": {
      "all": "அனைத்தும்",
      "lab": "ஆய்வு",
      "imaging": "படிமம்",
      "medication": "மருந்து",
      "procedure": "செயல்முறை",
      "consultation": "ஆலோசனை"
    },
    "columns": {
      "orderName": "ஆணை பெயர்",
      "code": "குறியீடு",
      "category": "வகை",
      "description": "விளக்கம்",
      "defaultPriority": "இயல்புநிலை முன்னுரிமை"
    },
    "details": {
      "orderCode": "ஆணை குறியீடு",
      "category": "வகை",
      "defaultPriority": "இயல்புநிலை முன்னுரிமை",
      "status": "நிலை",
      "cptCode": "CPT குறியீடு",
      "loincCode": "LOINC குறியீடு",
      "synonyms": "ஒத்த சொற்கள்",
      "description": "விளக்கம்",
      "active": "செயலில்",
      "inactive": "செயலில் இல்லை"
    },
    "loading": "பட்டியல் ஏற்றப்படுகிறது…",
    "loadError": "ஆணை பட்டியலை ஏற்ற முடியவில்லை",
    "emptyResults": "உங்கள் நிபந்தனைகளுக்குப் பொருந்தும் ஆணைகள் இல்லை.",
    "pagination": "மொத்தம் {{total}} இல் {{from}}-{{to}} காட்டப்படுகிறது",
    "pageIndicator": "{{totalPages}} இல் பக்கம் {{page}}",
    "favoriteAdd": "பிடித்தவைக்குச் சேர்",
    "favoriteRemove": "பிடித்தவையிலிருந்து அகற்று",
    "favoriteAdded": "பிடித்தவைக்குச் சேர்க்கப்பட்டது",
    "favoriteRemoved": "பிடித்தவையிலிருந்து அகற்றப்பட்டது"
  },
  "cosign": {
    "title": "ஆணை இணை-கையொப்ப வரிசை",
    "requiresCosign": "இணை-கையொப்பம் தேவை",
    "cosignedBy": "இணை-கையொப்பமிட்டவர்",
    "cosignDeadline": "இணை-கையொப்ப கடைசி தேதி",
    "queueEmpty": "இணை-கையொப்பம் தேவைப்படும் ஆணைகள் இல்லை.",
    "pendingCount": "{{count}} நிலுவையில்",
    "loading": "இணை-கையொப்ப வரிசை ஏற்றப்படுகிறது…",
    "loadError": "இணை-கையொப்ப வரிசையை ஏற்ற முடியவில்லை.",
    "columns": {
      "patient": "நோயாளி",
      "order": "ஆணை",
      "type": "வகை",
      "orderingProvider": "ஆணையிடும் மருத்துவர்",
      "priority": "முன்னுரிமை",
      "orderedDate": "ஆணை தேதி",
      "action": "செயல்"
    },
    "actions": {
      "cosign": "இணை-கையொப்பம்"
    },
    "toast": {
      "success": "ஆணை இணை-கையொப்பம் வெற்றிகரமாக முடிந்தது",
      "error": "ஆணையை இணை-கையொப்பமிட முடியவில்லை"
    },
    "cosigningAs": "{{name}} ஆக இணை-கையொப்பம்"
  },
  "sets": {
    "title": "ஆணை தொகுப்புகள்",
    "newOrderSet": "புதிய ஆணை தொகுப்பு",
    "addItem": "உருப்படியைச் சேர்",
    "requiredItem": "கட்டாயம்",
    "optionalItem": "விருப்பம்",
    "editMode": "திருத்தும் நிலை",
    "published": "வெளியிடப்பட்டது",
    "draft": "வரைவு",
    "archived": "காப்பகப்படுத்தப்பட்டது",
    "versionNotes": "பதிப்பு குறிப்புகள்",
    "createTitle": "புதிய ஆணை தொகுப்பை உருவாக்கு",
    "fields": {
      "name": "பெயர்",
      "category": "வகை",
      "specialty": "சிறப்புத்துறை",
      "description": "விளக்கம்"
    },
    "placeholders": {
      "name": "எ.கா., மார்பு வலி பரிசோதனை",
      "categorySelect": "வகையைத் தேர்வுசெய்…",
      "specialty": "எ.கா., அவசர மருத்துவம்",
      "description": "சுருக்கமான விளக்கம்…",
      "search": "ஆணை தொகுப்புகளைத் தேடு…"
    },
    "categories": {
      "chestPain": "மார்பு வலி",
      "sepsis": "செப்சிஸ்",
      "postOp": "அறுவை சிகிச்சைக்குப் பின்",
      "admission": "சேர்க்கை",
      "discharge": "விடுவிப்பு",
      "other": "மற்றவை"
    },
    "statusFilter": {
      "all": "அனைத்து நிலைகள்",
      "active": "செயலில்",
      "draft": "வரைவு",
      "archived": "காப்பகப்படுத்தப்பட்டது"
    },
    "columns": {
      "name": "பெயர்",
      "category": "வகை",
      "specialty": "சிறப்புத்துறை",
      "items": "உருப்படிகள்",
      "status": "நிலை",
      "version": "பதிப்பு",
      "actions": "செயல்கள்"
    },
    "itemColumns": {
      "seq": "வரிசை",
      "type": "வகை",
      "item": "உருப்படி",
      "priority": "முன்னுரிமை",
      "required": "கட்டாயம்"
    },
    "itemTypes": {
      "order": "ஆணை",
      "sectionHeader": "பிரிவு தலைப்பு",
      "instruction": "வழிகாட்டுதல்"
    },
    "actions": {
      "publish": "வெளியிடு",
      "archive": "காப்பகப்படுத்து",
      "cancel": "ரத்துசெய்",
      "create": "உருவாக்கு",
      "removeItem": "உருப்படியை அகற்று"
    },
    "loading": "ஆணை தொகுப்புகள் ஏற்றப்படுகின்றன…",
    "loadError": "ஆணை தொகுப்புகளை ஏற்ற முடியவில்லை",
    "emptyResults": "ஆணை தொகுப்புகள் இல்லை.",
    "expandLoading": "உருப்படிகள் ஏற்றப்படுகின்றன…",
    "expandEmpty": "இந்த ஆணை தொகுப்பில் உருப்படிகள் இல்லை.",
    "validationRequired": "பெயர், வகை மற்றும் சிறப்புத்துறை அவசியம்",
    "toast": {
      "created": "ஆணை தொகுப்பு உருவாக்கப்பட்டது",
      "createError": "ஆணை தொகுப்பை உருவாக்க முடியவில்லை",
      "published": "ஆணை தொகுப்பு வெளியிடப்பட்டது",
      "publishError": "ஆணை தொகுப்பை வெளியிட முடியவில்லை",
      "archived": "ஆணை தொகுப்பு காப்பகப்படுத்தப்பட்டது",
      "archiveError": "ஆணை தொகுப்பைக் காப்பகப்படுத்த முடியவில்லை",
      "itemRemoved": "உருப்படி அகற்றப்பட்டது",
      "itemRemoveError": "உருப்படியை அகற்ற முடியவில்லை"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "ஆணைகளைத் தேடு (ஆய்வு, படிம, மருந்து, செயல்முறை)…",
    "noResults": "\"{{query}}\" க்கான ஆணைகள் இல்லை",
    "categories": {
      "all": "அனைத்தும்",
      "lab": "ஆய்வு",
      "imaging": "படிமம்",
      "med": "மருந்து",
      "procedure": "செயல்முறை",
      "consultation": "ஆலோசனை"
    },
    "addAll": "அனைத்தையும் சேர் ({{count}})"
  },
  "worklist": {
    "title": "உத்தரவு பணிப்பட்டியல்",
    "countBadge": "{{count}} உத்தரவுகள்",
    "loading": "உத்தரவுகள் ஏற்றப்படுகின்றன…",
    "loadError": "உத்தரவுகளை ஏற்ற முடியவில்லை. மீண்டும் முயல்க.",
    "empty": "தற்போதைய வடிப்பான்களுடன் எந்த உத்தரவும் பொருந்தவில்லை.",
    "typeLabel": "உத்தரவு வகை",
    "allOption": "அனைத்தும்",
    "columns": {
      "patient": "நோயாளி",
      "order": "உத்தரவு",
      "type": "வகை",
      "priority": "முன்னுரிமை",
      "status": "நிலை",
      "ordered": "உத்தரவு நாள்"
    }
  }
}
